import { defineMessages } from 'react-intl';

export default defineMessages({
  TenantRoles: 'Roles',
  Name: 'Name',
  Save: 'Save',
  Add: 'Add',
  Cancel: 'Cancel',
  Functionality: 'Functionality',
  Read: 'Read',
  Write: 'Write',
  Create: 'Create',
  Update: 'Update',
  Delete: 'Delete',
  UseAdvanceWritePermissions: 'Use advance write permissions',
  EditTenantRole: 'Edit role',
  CreateTenantRole: 'Create role',
  DeleteConfirmationTitle: 'Delete?',
  DeleteRoleConfirmationMsg: 'Are you sure you want to delete this role?',
  Copy: 'Copy',
  CopyDefaultRole: 'Copy default role',
});
